import { FileUploadData } from "../../TypeScript/interfaces";
import { AxiosResponse, AxiosError } from "axios";
import { FileUploadDataErrors } from "../../TypeScript/interfaces";
import api from "../../axios/axios";

export const validateUploadInformations = (
  values: FileUploadData,
  country: string,
  warnings: string[]
) => {
  const errors = {
    salutationErr: false,
    salutationErrTxt: "",
    firstNameErr: false,
    firstNameErrTxt: "",
    lastNameErr: false,
    lastNameErrTxt: "",
    customerOrgErr: false,
    customerOrgErrTxt: "",
    phoneNbrErr: false,
    phoneNbrErrTxt: "",
    emailErr: false,
    emailErrTxt: "",
    ccFirstErr: false,
    ccFirstErrTxt: "",
    ccSecondErr: false,
    ccSecondErrTxt: "",
    acctNbrErr: false,
    acctNbrErrTxt: "",
    platformErr: false,
    securityCodeErr: false,
    isinErr: false,
    isinErrTxt: "",
    commonCodeErr: false,
    commonCodeErrTxt: "",
    securityNameErr: false,
    securityNameErrTxt: "",
    corpIdErr: false,
    corpIdErrTxt: "",
    recordDateErr: false,
    recordDateErrTxt: "",
    paymentDateErr: false,
    paymentDateErrTxt: "",
    grossPriceErr: false,
    grossPriceErrTxt: "",
    totalHoldingErr: false,
    totalHoldingErrTxt: "",
    taxYearErr: false,
    taxYearErrTxt: "",
    fileErr: false,
    fileErrTxt: "",
    validSetup: true,
  };

  if (!values.salutation || values.salutation === "none") {
    errors.salutationErr = true;
    errors.validSetup = false;
  }

  if (!values.firstName || values.firstName.trim() === "") {
    errors.firstNameErr = true;
    errors.validSetup = false;
  }

  if (!values.lastName || values.lastName.trim() === "") {
    errors.lastNameErr = true;
    errors.validSetup = false;
  }

  if (!values.customerOrg || values.customerOrg.trim() === "") {
    errors.customerOrgErr = true;
    errors.validSetup = false;
  }

  if (!values.phoneNbr || values.phoneNbr.trim() === "") {
    errors.phoneNbrErr = true;
    errors.validSetup = false;
  }

  if (!values.email || values.email.trim() === "") {
    errors.emailErr = true;
    errors.emailErrTxt = "Email address: is required";
    errors.validSetup = false;
  }

  if (!values.acctNbr || values.acctNbr.trim() === "") {
    errors.acctNbrErr = true;
    errors.validSetup = false;
    errors.acctNbrErrTxt = "Clearstream Account Number: is required.";
  }

  if (!values.platform || values.platform.trim() === "") {
    errors.platformErr = true;
    errors.validSetup = false;
  }

  if (country !== "Germany") {
    if (
      (!values.isin || values.isin.trim() === "") &&
      (!values.commonCode || values.commonCode.trim() === "")
    ) {
      errors.securityCodeErr = true;
      errors.validSetup = false;
    }

    const isinRegularExpresion = /^[a-zA-Z]{2}[a-zA-Z0-9]{10}$/;
    if (values.isin && isinRegularExpresion.exec(values.isin) === null) {
      errors.isinErr = true;
      errors.isinErrTxt = "Please enter a valid ISIN Code.";
      errors.validSetup = false;
    }

    const ccRegularExpresion = /^[0-9]{7,9}$/;
    if (
      values.commonCode &&
      ccRegularExpresion.exec(values.commonCode) === null
    ) {
      errors.commonCodeErr = true;
      errors.commonCodeErrTxt = "Please enter a valid Common Code.";
      errors.validSetup = false;
    }

    if (!values.securityName || values.securityName.trim() === "") {
      errors.securityNameErr = true;
      errors.validSetup = false;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const corpIdRegularExpresion = /^[a-zA-Z0-9]{0,16}$/;
    if (!values.corpId || values.corpId.trim() === "") {
      errors.corpIdErr = true;
      errors.validSetup = false;
    }

    if (!values.recordDate || values.recordDate.trim() === "") {
      errors.recordDateErr = true;
      errors.recordDateErrTxt =
        "Please enter the Record Date: using the format dd/mm/yyyyy";
      errors.validSetup = false;
    }

    if (
      (!values.paymentDate || values.paymentDate.trim() === "") &&
      country !== "South Korea" &&
      country !== "Japan"
    ) {
      errors.paymentDateErr = true;
      errors.paymentDateErrTxt =
        "Please enter the Payment Date: using the format dd/mm/yyyyy";
      errors.validSetup = false;
    }

    const grossPriceRegularExpresion = /^([0-9]+((,[0-9]{1})|(,[0-9]{2}))?)?$/;
    if (
      values.grossPrice &&
      grossPriceRegularExpresion.exec(values.grossPrice) === null
    ) {
      errors.grossPriceErr = true;
      errors.grossPriceErrTxt =
        "Gross Price per Unit: is not a valid price (e.g. 0,75 is a valid price).";
      errors.validSetup = false;
    }

    if (!values.totalHolding || values.totalHolding.trim() === "") {
      errors.totalHoldingErr = true;
      errors.totalHoldingErrTxt = "Total Holding: is required.";
      errors.validSetup = false;
    }
  }

  const totalHoldingRegularExpresion = /^[0-9]+$/;
  if (
    values.totalHolding &&
    totalHoldingRegularExpresion.exec(values.totalHolding) === null
  ) {
    errors.totalHoldingErr = true;
    errors.totalHoldingErrTxt = "Total Holding: must be a whole number.";
    errors.validSetup = false;
  }

  if (country === "Germany") {
    if (!values.taxYear || values.taxYear.trim() === "") {
      errors.taxYearErr = true;
      errors.validSetup = false;
      errors.taxYearErrTxt = "Taxt Year musn't be empty";
    }

    const currentYear = new Date().getFullYear();
    if (
      values.taxYear &&
      typeof Number(values.taxYear) === "number" &&
      Number(values.taxYear) > currentYear + 1
    ) {
      warnings.push("Tax Year value is incorrect");
    }
  }

  if (
    values.platform === "CASCADE" &&
    values.acctNbr &&
    values.acctNbr.length !== 7
  ) {
    errors.acctNbrErr = true;
    errors.acctNbrErrTxt = "CASCADE Account Number must be 7 characters.";
    errors.validSetup = false;
  }

  if (
    values.platform === "Creation" &&
    values.acctNbr &&
    values.acctNbr.length !== 5
  ) {
    errors.acctNbrErr = true;
    errors.acctNbrErrTxt = "Creation Account Number must be 5 characters.";
    errors.validSetup = false;
  }

  if (!values.attachedFileName || values.attachedFileName === "") {
    errors.fileErr = true;
    errors.fileErrTxt = "The uploaded file is empty.";
    errors.validSetup = false;
  }

  // check for < in the string
  if (values.firstName && values.firstName.includes("<")) {
    errors.validSetup = false;
    errors.firstNameErr = true;
    errors.firstNameErrTxt = "Invalid character '<'.";
  }

  if (values.lastName && values.lastName.includes("<")) {
    errors.validSetup = false;
    errors.lastNameErr = true;
    errors.lastNameErrTxt = "Invalid character '<'.";
  }

  if (values.customerOrg && values.customerOrg.includes("<")) {
    errors.validSetup = false;
    errors.customerOrgErr = true;
    errors.customerOrgErrTxt = "Invalid character '<'.";
  }

  if (values.phoneNbr && values.phoneNbr.includes("<")) {
    errors.validSetup = false;
    errors.phoneNbrErr = true;
    errors.phoneNbrErrTxt = "Invalid character '<'.";
  }

  if (values.email && values.email.includes("<")) {
    errors.validSetup = false;
    errors.emailErr = true;
    errors.emailErrTxt = "Invalid character '<'.";
  }

  if (values.ccFirst && values.ccFirst.includes("<")) {
    errors.validSetup = false;
    errors.ccFirstErr = true;
    errors.ccFirstErrTxt = "Invalid character '<'.";
  }

  if (values.ccSecond && values.ccSecond.includes("<")) {
    errors.validSetup = false;
    errors.ccSecondErr = true;
    errors.ccSecondErrTxt = "Invalid character '<'.";
  }

  if (values.acctNbr && values.acctNbr.includes("<")) {
    errors.validSetup = false;
    errors.acctNbrErr = true;
    errors.acctNbrErrTxt = "Invalid character '<'.";
  }

  if (values.isin && values.isin.includes("<")) {
    errors.validSetup = false;
    errors.isinErr = true;
    errors.isinErrTxt = "Invalid character '<'.";
  }

  if (values.commonCode && values.commonCode.includes("<")) {
    errors.validSetup = false;
    errors.commonCodeErr = true;
    errors.commonCodeErrTxt = "Invalid character '<'.";
  }

  if (values.securityName && values.securityName.includes("<")) {
    errors.validSetup = false;
    errors.securityNameErr = true;
    errors.securityNameErrTxt = "Invalid character '<'.";
  }

  if (values.corpId && values.corpId.includes("<")) {
    errors.validSetup = false;
    errors.corpIdErr = true;
    errors.corpIdErrTxt = "Invalid character '<'.";
  }

  if (values.recordDate && values.recordDate.includes("<")) {
    errors.validSetup = false;
    errors.recordDateErr = true;
    errors.recordDateErrTxt = "Invalid character '<'.";
  }

  if (values.paymentDate && values.paymentDate.includes("<")) {
    errors.validSetup = false;
    errors.paymentDateErr = true;
    errors.paymentDateErrTxt = "Invalid character '<'.";
  }

  if (values.grossPrice && values.grossPrice.includes("<")) {
    errors.validSetup = false;
    errors.grossPriceErr = true;
    errors.paymentDateErrTxt = "Invalid character '<'.";
  }

  if (values.totalHolding && values.totalHolding.includes("<")) {
    errors.validSetup = false;
    errors.totalHoldingErr = true;
    errors.totalHoldingErrTxt = "Invalid character '<'.";
  }

  if (values.taxYear && values.taxYear.includes("<")) {
    errors.validSetup = false;
    errors.taxYearErr = true;
    errors.taxYearErrTxt = "Invalid character '<'.";
  }

  /*
let key: keyof typeof values;
for (key in values) {    
  if (values[key] && typeof values[key] === "string" ) {
    values[key]?
  }
}
*/
  return errors;
};

export const dbValidations = async (
  fileUploadData: FileUploadData,
  errors: FileUploadDataErrors,
  warnings: string[]
) => {
  await api  
    .post("/bol-gui/v1/bol/validations", fileUploadData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response: AxiosResponse) => {
      fileUploadData.returnedError = "";
      fileUploadData.id = response.data.id;

      //see Validations.java for definition of the response
      if (response.data.accountError === "true") {
        errors.validSetup = false;
        errors.acctNbrErr = true;
        errors.acctNbrErrTxt = response.data.accountErrorText;
      }

      if (response.data.isinError === "true") {
        errors.isinErrTxt = response.data.isinErrorText;
        warnings.push(response.data.isinErrorText);
      }

      if (response.data.commonCodeError === "true") {
        errors.commonCodeErrTxt = response.data.commonCodeErrorText;
        warnings.push(response.data.commonCodeErrorText);
      }

      if (response.data.corpIdError === "true") {
        // Check if the error text contains the expected message
        // The text is comming from BE. See QueryServiceMyBatis.java
        if (
          response.data.corpIdErrorText &&
          response.data.corpIdErrorText.includes(
            "is not eligible for FR BO disclosure via BOL-GUI"
          )
        ) {
          errors.validSetup = false;
          errors.corpIdErr = true;
          errors.corpIdErrTxt = response.data.corpIdErrorText;
        } else {
          errors.corpIdErrTxt = response.data.corpIdErrorText;
          warnings.push(response.data.corpIdErrorText);
        }
      }

      if (response.data.fileExtensionError === "WrongFileExtension") {
        errors.validSetup = false;
        errors.fileErr = true;
        errors.fileErrTxt =
          response.data.fileExtensionErrorText || "File extension error.";
      }

      if (
        response.data.fileContentErrors != null &&
        response.data.fileContentErrors.length > 0
      ) {
        if (response.data.fileContentErrors.length > 10) {
          response.data.fileContentErrors.length = 10;
        }
        warnings.push(...response.data.fileContentErrors);
      }
    })
    .catch((error: AxiosError) => {
      console.log(JSON.stringify(error, null, 2));
      if (error.response?.data === "user not logged") {
        fileUploadData.returnedError = error.response?.data;
      } else {
        errors.validSetup = false;
        fileUploadData.returnedError = "UnexpectedError";
      }
    });
};
